import React from "react";
import styled from "@emotion/styled";
import { useHistory } from "react-router";
import { IconSparkle } from "./icons";

const Button = styled.button(
  ({ theme }) => `
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  border: 1px solid ${theme.primary};
  background: ${theme.primary};
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, opacity 0.15s;
  white-space: nowrap;

  &:hover {
    opacity: 0.85;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${theme.primary}4D, 0 0 0 4px ${
    theme.type === "dark" ? "#1e1e1e" : "#fff"
  };
  }
`
);

const iconStyle = { height: 14, width: 14, flexShrink: 0 };

export default function AskAIButton({ query, onClose, onAskAi }) {
  const history = useHistory();

  const handleClick = () => {
    if (onAskAi && query?.trim()) {
      onAskAi(query.trim());
      onClose?.();
      return;
    }
    const path = query?.trim()
      ? `/admin/data-settings/data-explorer?q=${encodeURIComponent(
          query.trim()
        )}`
      : "/admin/data-settings/data-explorer";
    history.push(path);
    onClose?.();
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      aria-label={
        query?.trim() ? "Ask AI with current search" : "Open AI Explorer"
      }
    >
      <IconSparkle style={iconStyle} />
      <span>Ask AI</span>
    </Button>
  );
}
